export type FormTypes = {
  firstName: string;
  lastName: string;
  dob: string;
  memberIdNumber: string;
  phone: string;
  email: string;
  address: string | number;
};

export const defaultValues = {
  firstName: '',
  lastName: '',
  dob: '',
  memberIdNumber: '',
  phone: '',
  email: '',
  address: '',
};
